module.exports = __webpack_public_path__ + "img/image-8.54357553.webp";